import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const PopupNotice = () => {
  const [showPopup, setShowPopup] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      const hasSeenPopup = localStorage.getItem("hasSeenPopup");

      if (!hasSeenPopup) {
        const timer = setTimeout(() => {
          setShowPopup(true);
          localStorage.setItem("hasSeenPopup", "true"); // mark as seen
        }, 2500);

        return () => clearTimeout(timer);
      }
    }
  }, [location.pathname]);

  const closePopup = () => setShowPopup(false);

  if (location.pathname !== "/") return null;

  return (
    <>
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-50">
          <div className="relative bg-white p-6 rounded-2xl shadow-xl max-w-md w-[90%] text-center border-t-4 border-orange-600">
            <button
              onClick={closePopup}
              className="absolute top-3 right-4 text-gray-500 hover:text-orange-700 text-2xl font-bold"
            >
              ×
            </button>

            <h2 className="text-xl font-semibold text-orange-700 mb-3">
              மூன்றாவது கோட்பாட்டின் விதியின்படி
            </h2>

            <p className="text-gray-800 text-[15px] leading-relaxed mb-4">
              ஆல்கஹாலிக்ஸ் அனானிமஸ் GSOSI அமைப்பும் இந்த இணையதளமும்
              பொருளாதார அடிப்படையில் இயங்குவதில்லை.
              எந்தவித கட்டணமும் வசூலிக்கப்படாது.
            </p>

            <p className="text-gray-800 text-[15px] leading-relaxed">
              எங்களின் பாதுகாப்பான எதிர்காலம் <br />
              <span className="font-semibold text-orange-700">
                AAவின் எதிர்காலத்தில் தான் உள்ளது.
              </span>
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default PopupNotice;
